module.exports = __webpack_public_path__ + "static/img/93-1.de4dad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/93-1.jpg
// module id = UIf1
// module chunks = 0